
import SuppliersApi from '@/api/suppliersApi'
const api = new SuppliersApi()

export default {
  async getSuppliersShortStatistic(context, payload) {
    let statistic = context.getters.getSuppliersShortStatistic,
      func = async () => {
        return await api.getSuppliersShortStatistic(payload.filter)
          .then(res => {
            context.commit('setSuppliersShortStatistic', res)
            return res
          })
      }
    if (!statistic?.length || payload.refresh) {
      return await func()
    } else {
      /* if ( payload ) {  // TODO:Чет я сомневаюсь что это условие хоть когда-то выполнится
        func()
      } */
      return statistic
    }
  },

  async getTenderSuppliersInfo(context, payload) {
    return await api.getTenderSuppliersInfo(payload)
      .then(res => {
        context.commit('setTenderSuppliersInfo', res)
        return res
      })
  },

  async getCrmVerificationFillingInfo(context, payload) {
    let verif = context.getters.getCrmVerificationFillingInfo
    if (! Object.keys(verif)?.length || payload) {
      return await api.getCrmVerificationFillingInfo()
        .then(res => {
          context.commit('setCrmVerificationFillingInfo', res)
          return res
        })
    } else {
      return verif
    }
  },

  async getSupplierBids(context, payload) {
    return await api.getSupplierBids(payload)
  },

  async getParticipationByTenderCategory(context, payload) {
    return await api.getParticipationByTenderCategory(payload)
  },

  async getTenderSupplierWithVerification(context, payload) {
    return await api.getTenderSupplierWithVerification(payload)
  },

  async getRatingCriterias(context, payload) {
    return await api.getRatingCriterias(payload)
  },

  async getSupplierRatings(context, payload) {
    return await api.getSupplierRatings(payload)
  },

  async getTenderSupplierParticipants(context, payload) {
    return await api.getTenderSupplierParticipants(payload)
  },

  async getSupplierTenders(context, payload) {
    return await api.getSupplierTenders(payload)
  },

  async getCrmSupplierVerificationByTender(context, payload) {
    return await api.getCrmSupplierVerificationByTender(payload)
  },

}
